import React from 'react'
import FormInput from '../../../../library/form/components/FormInput';
import FormROValue from '../../../../library/form/components/FormROValue1';

const WorkFlowPlanCriteriaRow = (props) => {
    const { formObject, rowKey } = props;


    return (
        <ul className="uiDPEditLine">
            <li className="uiInline uiColumn150">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "conditionType" }} className='uiVal' />
            </li>
            <li className="uiColumnCenter uiColumn150">
                <FormInput formObject={formObject} rowKey={rowKey} 
                    action={{ InputType: "input", paramName: "condition", actionId: "refresh", actionParam: {isSavePlanCriteria:"1"} }}
                />
            </li>
        </ul>
    )
}

export default WorkFlowPlanCriteriaRow